import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ciq00100-inquiry-form" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row q-gutter-x-sm" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  class: "row",
  style: {"margin-top":"32px"}
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "q-gutter-sm" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "q-gutter-sm" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  key: 1,
  class: "q-gutter-x-xs"
}

import Loading from 'quasar/src/plugins/Loading.js';;
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../common/axios-common';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../common/code/ResultStatusCode';
import { isFileExist } from '../common/utils/fileUtils';
import { isEmpty, isHalfKana } from '../common/utils/validateUtils';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';
import MessageChip from '../components/chip/MessageChip.vue';
import AlertDialog from '../components/dialogs/AlertDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CIQ00100',
  setup(__props) {

const router = useRouter();
const INQUIRY_TYPE = {
  COMPOUND: '1',
  OTHERS: '2',
};
// タブ
const tab = ref(INQUIRY_TYPE.COMPOUND);
// 化合物問い合わせ内容
const compoundInquiry = ref('');
// その他問い合わせ内容
const othersInquiry = ref('');
// 問い合わせ範囲
const inquiryRange = ref('未選択');
// 予算
const budget = ref('未選択');
// 必要容量
const capacity = ref('');
// アップロードファイル
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const files: any = ref('');
// 送信成功フラグ
const isConfirmed = ref(false);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);
// 添付ファイルパス
const inputFilePath = ref('');
// Dialog表示フラグ
const isDialogFlg = ref(false);
// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);
// アップロードDialog表示フラグ
const isUploadDisplayFlg = ref(false);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const inquiryForm = ref<any>();

/**
 * 問い合わせ内容を送信
 */
const sendMail = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
  const formData = new FormData();
  Loading.show();
  let path = '';
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    path = '/ciq001002/send-compound-confirm';
    formData.set('compoundInquiry', compoundInquiry.value);
    formData.set('capacity', capacity.value);
    formData.set('inputFilePath', inputFilePath.value);
    formData.set('inquiryRange', inquiryRange.value);
    formData.set('budget', budget.value);
    formData.set('file', files.value);
    // その他問い合わせタブが選択された場合
  } else {
    path = '/ciq001002/send-other-confirm';
    formData.set('otherInquiry', othersInquiry.value);
  }

  await axios
    .post(path, formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isDialogFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.CAPACITY_OVER_ERROR:
            case DetailResultStatusCode.FAILED_SAVE_DATA_ERROR:
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
            case DetailResultStatusCode.USER_NOT_EXIST_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * Formを初期化
 */
const resetForm = async () => {
  const reset = async () => {
    errMessage.value = '';
    isMessageChip.value = false;
    isConfirmed.value = false;
    isDialogFlg.value = false;
    compoundInquiry.value = '';
    othersInquiry.value = '';
    inquiryRange.value = '未選択';
    budget.value = '未選択';
    capacity.value = '';
    files.value = '';
  };
  await reset();
  inquiryForm.value.resetValidation();
};

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 添付ファイルを保存する
 */
const saveUploadFile = async () => {
  Loading.show();
  errMessage.value = '';
  isMessageChip.value = false;

  const formData = new FormData();
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    formData.set('compoundInquiry', compoundInquiry.value);
    formData.set('capacity', capacity.value);
    formData.set('file', files.value);
    // その他問い合わせタブが選択された場合
  } else {
    formData.set('compoundInquiry', othersInquiry.value);
  }
  await axios
    .post('/ciq001001/inquiry', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isConfirmed.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.CAPACITY_OVER_ERROR:
            case DetailResultStatusCode.FAILED_SAVE_DATA_ERROR:
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * ファイルアップロードチェック
 */
const checkUploadFile = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    // ファイルが添付された状態
    if (files.value) {
      isFileExist(files.value).then((value) => {
        if (value) {
          saveUploadFile();
        } else {
          dialogTitle.value = 'ファイル読み込みエラー';
          dialogLevel.value = 'error';
          if (files.value.size === 0) {
            dialogText.value = [
              '選択したファイルは内容が設定されていません。',
              'ファイルを再度選択してください。',
            ];
          } else {
            dialogText.value = [
              '更新または削除されたファイルがあるため、アップロードできませんでした。',
              'ファイルを再度選択してください。',
            ];
          }
          isConfFlg.value = true;
          isUploadDisplayFlg.value = true;
        }
      });
    }
    // 添付ファイルなしの場合、チェックを行わない
    else {
      saveUploadFile();
    }
  }
  // その他問い合わせタブが選択された場合
  else {
    isConfFlg.value = false;
    isUploadDisplayFlg.value = false;
    saveUploadFile();
  }
  window.scrollTo({ top: 0 });
};

/**
 * ファイルアップロードチェック(確認画面)
 */
const checkUploadFileConfirm = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
  // 化合物問い合わせタブが選択された場合
  if (tab.value === '1') {
    // ファイルが添付された状態
    if (files.value) {
      isFileExist(files.value).then((value) => {
        if (value) {
          sendMail();
        } else {
          dialogTitle.value = 'ファイル読み込みエラー';
          dialogLevel.value = 'error';
          if (files.value.size === 0) {
            dialogText.value = [
              '選択したファイルは内容が設定されていません。',
              'ファイルを再度選択してください。',
            ];
          } else {
            dialogText.value = [
              '更新または削除されたファイルがあるため、アップロードできませんでした。',
              'ファイルを再度選択してください。',
            ];
          }
          isConfFlg.value = true;
          isUploadDisplayFlg.value = true;
        }
      });
    }
    // 添付ファイルなしの場合、チェックを行わない
    else {
      sendMail();
    }
  }
  // その他問い合わせタブが選択された場合
  else {
    isConfFlg.value = false;
    isUploadDisplayFlg.value = false;
    sendMail();
  }
  window.scrollTo({ top: 0 });
};

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[18] || (_cache[18] = [
        _createTextVNode("お問い合わせ")
      ])),
      _: 1
    }),
    _createVNode(_component_q_form, {
      ref_key: "inquiryForm",
      ref: inquiryForm,
      autofocus: "",
      greedy: "",
      onSubmit: checkUploadFile,
      onValidationError: resetError
    }, {
      default: _withCtx(() => [
        _createVNode(MessageChip, {
          display: isMessageChip.value,
          level: "E",
          message: errMessage.value
        }, null, 8, ["display", "message"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_tabs, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
            dense: "",
            class: "text-grey",
            "active-color": "primary",
            "indicator-color": "primary",
            align: "justify",
            breakpoint: 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tab, {
                name: INQUIRY_TYPE.COMPOUND,
                label: "化合物に関するお問い合わせ",
                disable: isConfirmed.value,
                style: {"font-size":"1.1rem"}
              }, null, 8, ["name", "disable"]),
              _createVNode(_component_q_tab, {
                name: INQUIRY_TYPE.OTHERS,
                disable: isConfirmed.value,
                label: "その他のお問い合わせ",
                style: {"font-size":"1.1rem"}
              }, null, 8, ["name", "disable"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_card, {
            bordered: "",
            flat: "",
            class: "bg-grey-2 form-card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tab_panels, {
                modelValue: tab.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((tab).value = $event)),
                animated: "",
                class: "bg-grey-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tab_panel, {
                    name: INQUIRY_TYPE.COMPOUND,
                    class: "q-gutter-y-md"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("label", {
                            class: _normalizeClass(isConfirmed.value ? '' : 'requier')
                          }, "お問い合わせ内容", 2),
                          _createVNode(_component_q_input, {
                            modelValue: compoundInquiry.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compoundInquiry).value = $event)),
                            outlined: !isConfirmed.value,
                            dense: "",
                            rules: [
                      (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                      (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
                    ],
                            maxlength: "750",
                            counter: "",
                            type: "textarea",
                            rows: "5",
                            clearable: "",
                            style: _normalizeStyle(!isConfirmed.value && 'background: var(--q-white); padding:0;'),
                            readonly: isConfirmed.value,
                            class: "q-mb-md input-area left-input"
                          }, null, 8, ["modelValue", "outlined", "rules", "style", "readonly"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", null, "必要容量", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: capacity.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((capacity).value = $event)),
                            outlined: !isConfirmed.value,
                            dense: "",
                            rules: [(val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana')],
                            maxlength: "10",
                            class: "input-area",
                            clearable: "",
                            style: _normalizeStyle(!isConfirmed.value && 'background: var(--q-white); padding:0;'),
                            readonly: isConfirmed.value,
                            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                          }, null, 8, ["modelValue", "outlined", "rules", "style", "readonly"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", null, "添付ファイル", -1)),
                          _createVNode(_component_q_file, {
                            modelValue: files.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((files).value = $event)),
                            outlined: !isConfirmed.value,
                            dense: "",
                            clearable: "",
                            hint: "4MB以下のファイルを添付してください。",
                            error: isMessageChip.value,
                            style: _normalizeStyle(!isConfirmed.value && 'background: var(--q-white); padding:0;'),
                            readonly: isConfirmed.value
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_q_icon, { name: "attach_file" })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "outlined", "error", "style", "readonly"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", null, "お問い合わせ範囲", -1)),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_q_radio, {
                              modelValue: inquiryRange.value,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inquiryRange).value = $event)),
                              disable: isConfirmed.value,
                              val: "未選択",
                              label: "未選択"
                            }, null, 8, ["modelValue", "disable"]),
                            _createVNode(_component_q_radio, {
                              modelValue: inquiryRange.value,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inquiryRange).value = $event)),
                              disable: isConfirmed.value,
                              val: "市販在庫品のみ希望",
                              label: "市販在庫品のみ希望"
                            }, null, 8, ["modelValue", "disable"]),
                            _createVNode(_component_q_radio, {
                              modelValue: inquiryRange.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((inquiryRange).value = $event)),
                              disable: isConfirmed.value,
                              val: "ご注文後の合成品でも可能",
                              label: "ご注文後の合成品でも可能"
                            }, null, 8, ["modelValue", "disable"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", null, "ご予算", -1)),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_q_radio, {
                              modelValue: budget.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((budget).value = $event)),
                              disable: isConfirmed.value,
                              val: "未選択",
                              label: "未選択"
                            }, null, 8, ["modelValue", "disable"]),
                            _createVNode(_component_q_radio, {
                              modelValue: budget.value,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((budget).value = $event)),
                              disable: isConfirmed.value,
                              val: "10万円以内",
                              label: "10万円以内"
                            }, null, 8, ["modelValue", "disable"]),
                            _createVNode(_component_q_radio, {
                              modelValue: budget.value,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((budget).value = $event)),
                              disable: isConfirmed.value,
                              val: "50万円以内",
                              label: "50万円以内"
                            }, null, 8, ["modelValue", "disable"]),
                            _createVNode(_component_q_radio, {
                              modelValue: budget.value,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((budget).value = $event)),
                              disable: isConfirmed.value,
                              val: "100万円以内",
                              label: "100万円以内"
                            }, null, 8, ["modelValue", "disable"]),
                            _createVNode(_component_q_radio, {
                              modelValue: budget.value,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((budget).value = $event)),
                              disable: isConfirmed.value,
                              val: "100万円以上",
                              label: "100万円以上"
                            }, null, 8, ["modelValue", "disable"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["name"]),
                  _createVNode(_component_q_tab_panel, {
                    name: INQUIRY_TYPE.OTHERS
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("label", {
                            class: _normalizeClass(isConfirmed.value ? '' : 'requier')
                          }, "お問い合わせ内容", 2),
                          _createVNode(_component_q_input, {
                            modelValue: othersInquiry.value,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((othersInquiry).value = $event)),
                            outlined: !isConfirmed.value,
                            dense: "",
                            rules: [
                      (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                      (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
                    ],
                            "lazy-rules": "",
                            type: "textarea",
                            rows: "5",
                            maxlength: "750",
                            counter: "",
                            class: "input-area left-input",
                            clearable: "",
                            style: _normalizeStyle(
                      !isConfirmed.value && 'background: var(--q-white); padding:0;margin-bottom: 20px;'
                    ),
                            readonly: isConfirmed.value
                          }, null, 8, ["modelValue", "outlined", "rules", "style", "readonly"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["name"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_q_card_actions, { align: "center" }, {
                default: _withCtx(() => [
                  (!isConfirmed.value)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        label: "お問い合わせ内容確認",
                        color: "primary",
                        outline: "",
                        style: {"width":"200px","background":"var(--q-white) !important"},
                        type: "submit"
                      }))
                    : _createCommentVNode("", true),
                  (isConfirmed.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_q_btn, {
                          color: "grey-7",
                          outline: "",
                          label: "戻る",
                          style: {"min-width":"120px","background":"var(--q-white) !important"},
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (isConfirmed.value = false))
                        }),
                        _createVNode(_component_q_btn, {
                          label: "送信",
                          icon: "mdi-email-outline",
                          color: "primary",
                          style: {"min-width":"120px"},
                          onClick: checkUploadFileConfirm
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(AlertDialog, {
      display: isDialogFlg.value,
      level: "information",
      confirmation: "",
      title: "お問い合わせ完了",
      text: [
        'お問い合わせありがとうございます。',
        '',
        '担当者より折り返しご連絡させていただきますので、今しばらくお待ちください。',
        '２営業日を過ぎても返答がない場合は、メールの送受信に不具合がある可能性がございますので、お手数ですがお電話にて下記までお問合せください。',
        '',
        'TEL:03-6262-6467',
      ],
      onComplete: resetForm
    }, null, 8, ["display"]),
    _createVNode(AlertDialog, {
      display: isUploadDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[16] || (_cache[16] = ($event: any) => (isUploadDisplayFlg.value = false)),
      onClose: _cache[17] || (_cache[17] = ($event: any) => (isUploadDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})